import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { Grid, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  createFacility,
  deleteFacilityById,
  getClinicFacilities,
  getClinicFacilityList,
  getLocations,
  updateFacilityById,
} from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import { delBtn, w20h20BlueIcon } from "../../../util/CommonIconStyle";
import { facilityTypes } from "../../../util/dropList";

const requiredFieldList = ["facilityType", "name", "primaryStorage"];
const tblHdrs = [
  "sNo",
  "name",
  "facilityType",
  "newStatus",
  "createdBy",
  "createdDate",
  "actions",
];

const nameExpan = {
  ConsultationRoom: "Consultation Room",
  OperationTheatre: "Operation Theatre",
  Kennel: "Kennel",
  Devices: "Devices",
  BathBays: "Bath Bays",
  HomeKit: "Home Kit",
  TreatmentArea: "Treatment Area",
};

const facilityTypeFilterList = [
  { name: "All", value: "all" },
  ...facilityTypes,
];

const Facilities = () => {
  const dispatch = useDispatch();
  const locationsAndFacilitiesFetchedRef = useRef(false);
  const isFirstFilterRenderRef = useRef(true);
  const [searchValue, setSearchValue] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [modVisible, setModVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [modValues, setModValues] = useState({});
  const [modErrors, setModErrors] = useState({});
  const [delModVisible, setDelModVisible] = useState(false);
  const [page, setPage] = useState(1);
  const { locationList, facilityList, selectedClinicBranch } = useSelector(
    (state) => state?.clinic,
  );
  const role = localStorage.getItem("role");
  const url = "";
    // role === "ROLE_DOCTOR" && selectedClinicBranch?.branchId
    //   ? `?clinicId=${selectedClinicBranch?.branchId}`
    //   : "";
  const itemSize = 10;

  useEffect(() => {
    if (locationsAndFacilitiesFetchedRef.current) return;
    // if (role === "ROLE_DOCTOR") {
    //   if (!selectedClinicBranch?.branchId) return;
    //   locationsAndFacilitiesFetchedRef.current = true;
    //   const reqUrl = `?clinicId=${selectedClinicBranch?.branchId}`;
    //   onLocationApiCall(reqUrl);
    //   onFacilitiesApiCall(1, reqUrl);
    //   return;
    // }
    locationsAndFacilitiesFetchedRef.current = true;
    onLocationApiCall();
    onFacilitiesApiCall(1);
  }, [selectedClinicBranch, role, dispatch]);

  useEffect(() => {
    if (isFirstFilterRenderRef.current) {
      isFirstFilterRenderRef.current = false;
      return;
    }
    if (!locationsAndFacilitiesFetchedRef.current) return;
    let reqUrl = null;
    if (role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      reqUrl = `?clinicId=${selectedClinicBranch?.branchId}`;
    }
    onFacilitiesApiCall(1, reqUrl);
  }, [filterType, searchValue]);

  const onLocationApiCall = (url = "") => {
    dispatch(getLocations(url));
  };

  const onFacilitiesApiCall = (pge = 1, url = null) => {
    setPage(pge);
    const params = new URLSearchParams(url?.replace("?", "") || "");
    params.set("page", pge);
    params.set("itemSize", itemSize);
    if (searchValue?.length > 0) params.set("name", searchValue);
    if (filterType !== "all") params.set("type", filterType);
    dispatch(getClinicFacilityList(`?${params.toString()}`));
  };

  const getLocationList = (locationId = null) => {
    const reqList =
      locationList?.length > 0
        ? locationList
            ?.filter(
              (li) =>
                (locationId ? li?.id !== locationId : true) &&
                li?.locationType?.toLowerCase() === "storage",
              // li?.locationType?.toLowerCase() !== "consumption",
            )
            ?.map((li) => ({
              name: li?.locationName,
              value: li?.id,
            }))
        : [];
    return reqList;
  };

  const onCreate = () => {
    setModVisible(true);
  };

  const onCloseModal = () => {
    setModVisible(false);
    setModValues({});
    setModErrors({});
  };

  const onChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = { ...modValues, [name]: value };
    setModValues(reqObj);
    setModErrors({
      ...modErrors,
      [name]: !value
        ? name === "secondaryStorage"
          ? ""
          : "This field is required"
        : "",
    });
  };

  const onFilterTypeChange = (e) => {
    setFilterType(e?.target?.value);
    setPage(1);
  };

  const isFieldsNotValid = () => {
    const errObj = {};
    requiredFieldList.forEach((fld) => {
      if (!modValues?.[fld] || modValues?.[fld]?.length === 0) {
        errObj[fld] =
          fld === "primaryStorage"
            ? modValues?.facilityType === "Devices"
              ? ""
              : "This field is required"
            : "This field is required";
      }
    });
    setModErrors({ ...modErrors, ...errObj });
    return Object.values(errObj).some((err) => err);
  };

  const onSubmit = () => {
    if (isFieldsNotValid()) return;
    const data = {
      type: modValues?.facilityType,
      name: modValues?.name,
      status: selectedItem?.status ?? true,
    };
    if (modValues?.secondaryStorage) {
      data.secondaryStorage = modValues?.secondaryStorage;
    }
    if (modValues?.primaryStorage) {
      data.primaryStorage = modValues?.primaryStorage;
    }
    if (!selectedItem) {
      // const locObj = {
      //   locationName: modValues?.name,
      //   locationType: "Consumption",
      //   category: "Clinic",
      // };
      // dispatch(createLocation(locObj)).then((locRes) => {
      //   if (locRes?.payload) {
      //     data.primaryStorage = locRes?.payload?.data?.data?.id;
      dispatch(createFacility(data)).then((res) => {
        if (res?.payload) {
          onCloseModal();
          dispatch(getClinicFacilities(url));
          dispatch(getLocations(url));
        }
      });
      // }
      // });
    } else {
      // data.primaryStorage = selectedItem?.primaryStorage;
      dispatch(
        updateFacilityById({ data, facilityId: selectedItem?.facilityId }),
      ).then((res) => {
        if (res?.payload) {
          // if (selectedItem?.name !== modValues?.name) {
          //   const locObj = {
          //     locationName: modValues?.name,
          //     locationType: "Consumption",
          //     category: "Clinic",
          //   };
          //   dispatch(
          //     updateLocationById({
          //       locationId: selectedItem?.primaryStorage,
          //       data: locObj,
          //     })
          //   ).then((locRes) => {
          //     if (locRes?.payload) {
          //       dispatch(getLocations());
          //     }
          //   });
          // }
          onCloseModal();
          dispatch(getClinicFacilities(url));
        }
      });
    }
  };

  const handleDelete = (facility) => {
    setSelectedItem(facility);
    setDelModVisible(true);
  };

  const handleEdit = (facility) => {
    setModValues({
      facilityType: facility?.type,
      name: facility?.name,
      primaryStorage: facility?.primaryStorage,
      secondaryStorage: facility?.secondaryStorage,
    });
    setSelectedItem(facility);
    setModVisible(true);
  };

  const handleChangeSwitch = (status, facility) => {
    const data = {
      type: facility?.type,
      name: facility?.name,
      primaryStorage: facility?.primaryStorage,
      status,
    };
    if (facility?.secondaryStorage) {
      data.secondaryStorage = facility?.secondaryStorage;
    }
    dispatch(
      updateFacilityById({ data, facilityId: facility?.facilityId }),
    ).then((res) => {
      if (res?.payload) {
        dispatch(getClinicFacilities(url));
      }
    });
  };

  const getTableData = () => {
    return facilityList?.data?.map((row, index) => ({
      sNo: (page - 1) * itemSize + index + 1,
      name: row?.name,
      facilityType: nameExpan?.[row?.type],
      newStatus: (
        <div>
          <div>
            <CustomSwitch
              value={row?.status}
              onChange={(e) => handleChangeSwitch(e?.target?.value, row)}
              greenToRed
            />
          </div>
          <div>{row?.status ? "Active" : "Under Maintenance"}</div>
        </div>
      ),
      createdBy: row?.userName || "-",
      createdDate: new Date(row?.createdDate).toLocaleDateString(),
      actions: (
        <div className="flex-row-ali-cen">
          <div className="cursor" onClick={() => handleEdit(row)}>
            <div className="flex-center">
              <EditIcon sx={w20h20BlueIcon} />
            </div>
            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
              Edit
            </Typography>
          </div>
          <div className="cursor ml15" onClick={() => handleDelete(row)}>
            <div className="flex-center">
              <DeleteOutlineIcon sx={delBtn} />
            </div>
            <Typography className="red3 fs8 txt-semi-bold text-align-center">
              Delete
            </Typography>
          </div>
        </div>
      ),
    }));
  };

  const onCloseDelMod = () => {
    setDelModVisible(false);
    setSelectedItem(null);
  };

  const onConfirmDelete = () => {
    dispatch(deleteFacilityById(selectedItem?.facilityId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        dispatch(getClinicFacilities(url));
      }
    });
  };

  const handleChangePage = (e, pge) => {
    let url = null;
    if (role === "ROLE_DOCTOR") {
      if (!selectedClinicBranch?.branchId) return;
      locationsAndFacilitiesFetchedRef.current = true;
      url = `?clinicId=${selectedClinicBranch?.branchId}`;
    }
    onFacilitiesApiCall(pge, url);
  };

  return (
    <>
      <div className="flex-row mt20">
        <div className="w30Per" />
        <div className="w40Per">
          <div className="flex-row-ali-cen flex-center">
            <CustomTextField
              placeholder="Search"
              fullWidth
              name="search"
              handleChange={(e) => setSearchValue(e?.target?.value)}
              value={searchValue}
              backgroundColor={AppColors.lightBlue2}
            />
            <div className="ml20">
              <CustomButton text="Create" onClick={onCreate} smallBtn />
            </div>
          </div>
        </div>
        <div className="w30Per">
          <div className="flex1-end">
            <div className="w60Per mr30">
              <CustomSelect
                list={facilityTypeFilterList}
                value={filterType}
                name="facilityType"
                label="Facility Type"
                handleChange={onFilterTypeChange}
                select
                backgroundColor={AppColors.lightBlue2}
              />
            </div>
          </div>
        </div>
      </div>

      <CustomTable
        grey
        columns={tblHdrs}
        datas={getTableData()}
        totalRecords={facilityList?.totalRecords}
        rowsPerPage={itemSize}
        page={page}
        handleChangePage={handleChangePage}
      />

      <CustomModal
        rightModal
        open={modVisible}
        onClose={onCloseModal}
        modalWidth={30}
        header={selectedItem ? "Edit" : "Create"}
      >
        <div className="scroll-80vh">
          <Grid container spacing={2} className="ph20 mt5">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomSelect
                list={facilityTypes}
                value={modValues?.facilityType}
                name="facilityType"
                error={!!modErrors?.facilityType}
                label="Facility Type *"
                helperText={modErrors?.facilityType}
                handleChange={onChange}
                select
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                value={modValues?.name}
                name="name"
                error={!!modErrors?.name}
                label={`Name ${modValues?.facilityType !== "Devices" ? "*" : ""}`}
                helperText={modErrors?.name}
                handleChange={onChange}
                fullWidth
              />
            </Grid>
            {modValues?.facilityType !== "Devices" ? (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomSelect
                    list={getLocationList()}
                    value={modValues?.primaryStorage}
                    name="primaryStorage"
                    error={!!modErrors?.primaryStorage}
                    label={`Primary Location ${modValues?.facilityType !== "Devices" ? "*" : ""}`}
                    helperText={modErrors?.primaryStorage}
                    handleChange={onChange}
                    select
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <CustomSelect
                    list={getLocationList(modValues?.primaryStorage)}
                    value={modValues?.secondaryStorage}
                    name="secondaryStorage"
                    error={!!Location?.secondaryStorage}
                    label="Secondary Location"
                    helperText={modErrors?.secondaryStorage}
                    handleChange={onChange}
                    select
                  />
                </Grid>
              </>
            ) : null}

            <div className="flex1-center mt20">
              <div>
                <CustomButton text="Submit" onClick={onSubmit} smallBtn />
              </div>
            </div>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVisible}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the facility?
        </Typography>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                smallBtn
                onClick={onConfirmDelete}
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Facilities;
